import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSnackbar } from "notistack";
import Feed, { GroupInfo } from "./Feed";
import { groupDetail, LeaveGroup } from "src/DAL/Community/Community";
import { useContentSetting } from "src/Hooks/ContentContext/ContentSettingState";
import CustomConfirmation from "src/components/GeneralComponents/CustomConfirmation";
import { gr } from "src/design-system/tokens";
import icons from "src/design-system/icons";
import GrPage from "src/design-system/components/GrPage";
import GrPageHeader from "src/design-system/components/GrPageHeader";
import GrButton from "src/design-system/components/GrButton";
import GrIcon from "src/design-system/components/GrIcon";
import GrLoader from "src/design-system/components/GrLoader";
import GrCard from "src/design-system/components/GrCard";

// /group-feed/:id (opened from a group notification): the group's header and info, then its feed.
export default function GroupsFeedsDetail() {
  const params = useParams();
  const navigate = useNavigate();
  const { setSelectedGroup } = useContentSetting();
  const [communityGroup, setCommunityGroup] = useState({});
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [openLeave, setOpenLeave] = useState(false);

  const handleMyPosts = () => {
    navigate(`/my-posts`, { state: communityGroup });
  };

  const handleGroupLeave = async () => {
    setOpenLeave(false);
    const result = await LeaveGroup(communityGroup.community_group_slug);
    if (result.code === 200) {
      // Same as leaving from the feed popup: the left group is no longer the remembered one.
      localStorage.removeItem("selectedGroup");
      setSelectedGroup("");
      navigate(`/community-area`);
      enqueueSnackbar("You have Successfully left the Group", {
        variant: "success",
      });
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const getGroupDetail = async () => {
    setIsLoading(true);
    const result = await groupDetail(params.id);
    if (result.code === 200) {
      setCommunityGroup(result.community_group);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getGroupDetail();
  }, [params.id]);

  if (isLoading) {
    return <GrLoader sx={{ py: gr.space[12] }} />;
  }

  return (
    <GrPage sx={{ pb: gr.space[8] }}>
      <GrPageHeader
        onBack={() => navigate(-1)}
        title={communityGroup.title || ""}
        actions={
          <>
            <GrButton
              variant="danger"
              startIcon={<GrIcon icon={icons.logOut} />}
              onClick={() => setOpenLeave(true)}
            >
              Leave Group
            </GrButton>
            <GrButton variant="outline" onClick={handleMyPosts}>
              My Posts
            </GrButton>
          </>
        }
      />
      <GrCard sx={{ mb: gr.space[6] }}>
        <GroupInfo group={communityGroup} />
      </GrCard>
      <Feed groupFeed={true} group={params.id} />
      <CustomConfirmation
        open={openLeave}
        setOpen={setOpenLeave}
        title={"Are you sure you want to Leave this Group?"}
        handleAgree={handleGroupLeave}
      />
    </GrPage>
  );
}
